import { AnnouncementType } from 'components/admin/Announcements/utils';
import { useBanners } from 'components/GlobalBanners/globalBanners';
import { useLegacyNotifications } from 'controllers/contexts/legacyGlobalNotifications';
import { uniqBy } from 'lodash';
import { useMemo } from 'react';

/**
 * Hook to get the total count of active notifications
 * This includes both global banners and APP_WIDE legacy notifications
 * (excludes MESSAGE_PLANNER and EMERGENCY notifications)
 */
export const useNotificationCount = (): number => {
  const { banners } = useBanners();
  const { notifications: legacyNotifications } = useLegacyNotifications();

  const notificationCount = useMemo(() => {
    const filteredBanners = banners.filter(
      (banner) => banner?.announcementType !== AnnouncementType.EMERGENCY,
    );

    // Count global banners
    const globalBannerCount = uniqBy(filteredBanners, 'id').length;

    // Count only APP_WIDE legacy notifications (exclude MESSAGE_PLANNER and EMERGENCY)
    const filteredLegacyNotifications = legacyNotifications.filter(
      (notification) =>
        !notification.data.announcementType ||
        notification.data.announcementType === AnnouncementType.APP_WIDE,
    );
    const legacyNotificationCount = uniqBy(
      filteredLegacyNotifications,
      'id',
    ).length;

    return globalBannerCount + legacyNotificationCount;
  }, [banners, legacyNotifications]);

  return notificationCount;
};
